@if (loading) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

@if (!loading && !data) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    @if (currentClient.client_id !== 0) {
      <div class="text-center">
        <h1 class="text-warning">No Subscription Found!</h1>
        <p class="text-muted">You must have an active subscription to see this page.</p>
      </div>
    }
    @if (currentClient.client_id === 0) {
      <div class="text-center">
        <h1 class="text-warning">COMING SOON</h1>
        <p class="text-muted">We need to decide on a design for this page first, and what to show on it.</p>
      </div>
    }
  </div>
}

@if (!loading && data) {
  <ngx-simplebar class="mx-n3 px-4 file-manager-content-scroll">
    <div class="row h-100">
      <div class="col">
        <div class="row">
          @for (item of statData; track item; let i = $index) {
            <div class="col-xl-4 col-md-6">
              <div class="card card-animate overflow-hidden" style="height: 150px;">
                <div class="position-absolute start-0" style="z-index: 0;">
                  <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 120" width="200" height="120">
                    <style>.s0 { opacity: .05; fill: var(--vz-success) }</style>
                    <path id="Shape 8" class="s0" d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z" />
                  </svg>
                </div>
                <div class="card-body" style="z-index:1 ;">
                  <div class="d-flex align-items-center">
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title rounded-2 fs-2 {{ item.class }}">
                        <i class="{{ item.icon }} ri-lg"></i>
                      </span>
                    </div>
                    <div class="flex-grow-1 overflow-hidden ms-3">
                      <p class="text-uppercase fw-medium text-muted text-truncate" [ngClass]="i > 0 ? 'mb-0' : 'mb-4'">{{item.title}}</p>
                      <div class="d-flex align-items-center" [ngClass]="i > 0 ? 'mb-0' : 'mb-4'">
                        <h4 class="fs-4 flex-grow-1 mb-0">
                          <span [countUp]="item.value" class="counter-value" [options]="option"></span>{{ item.limit ? '/' + item.limit : '' }}
                        </h4>
                        @if (i > 0) {
                          <circle-progress
                            [percent]="item.persantage || 0"
                            [radius]="30"
                            [outerStrokeWidth]="3"
                            [showInnerStroke]="false"
                            [outerStrokeColor]="item.circle_color"
                            [animation]="true"
                            [animationDuration]="500"
                            [showSubtitle]=false
                            [titleColor]="item.circle_color"
                            [unitsColor]="item.circle_color">
                          </circle-progress>
                        }
                      </div>
                      <a href="javascript:void(0);" routerLink="{{ item.route }}" class="text-decoration-underline">{{ item.link }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-6">
            <div class="card">
              <div class="card-header align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">Assessments Status (All Times)</h4>
              </div>
              <div class="card-body">
                <ngx-charts-pie-chart class="d-flex justify-content-center align-items-center" [view]="[200,200]" [scheme]="colorScheme" [results]="examinesSeries" [legend]="false" [labels]="false" [doughnut]="true" [legendTitle]="''"></ngx-charts-pie-chart>
                <div class="mt-2">
                  <div class="text-center mb-2">
                    <h2 class="ff-secondary mb-0">{{ data.assessments.all_times }}</h2>
                    <p class="text-muted mb-0">Total Assessments</p>
                  </div>
                  <div class="d-flex justify-content-between border-bottom border-bottom-dashed py-2">
                    <p class="fw-medium mb-0">
                      <i class="ri-checkbox-blank-circle-fill text-success align-middle me-2"></i> Completed
                    </p>
                    <div>
                      <span>{{ data.assessments.completed }} Assessments</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between border-bottom border-bottom-dashed py-2">
                    <p class="fw-medium mb-0">
                      <i class="ri-checkbox-blank-circle-fill text-primary align-middle me-2"></i> In Process
                    </p>
                    <div>
                      <span>{{ data.assessments.in_process }} Assessments</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between border-bottom border-bottom-dashed py-2">
                    <p class="fw-medium mb-0">
                      <i class="ri-checkbox-blank-circle-fill text-warning align-middle me-2"></i> Yet to Start
                    </p>
                    <div>
                      <span>{{ data.assessments.yet_to_start }} Assessments</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between py-2">
                    <p class="fw-medium mb-0">
                      <i class="ri-checkbox-blank-circle-fill text-danger align-middle me-2"></i> Failed
                    </p>
                    <div>
                      <span>{{ data.assessments.failed }} Assessments</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-header align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">Conversations Status (All Times)</h4>
              </div>
              <div class="card-body">
                <ngx-charts-pie-chart class="d-flex justify-content-center align-items-center" [view]="[200,200]" [scheme]="colorScheme" [results]="conversationsSeries" [legend]="false" [labels]="false" [doughnut]="true" [legendTitle]="''"></ngx-charts-pie-chart>
                <div class="mt-2">
                  <div class="text-center mb-2">
                    <h2 class="ff-secondary mb-0">{{ data.conversations.all_times }}</h2>
                    <p class="text-muted mb-0">Total Conversations</p>
                  </div>
                  <div class="d-flex justify-content-between border-bottom border-bottom-dashed py-2">
                    <p class="fw-medium mb-0">
                      <i class="ri-checkbox-blank-circle-fill text-success align-middle me-2"></i> Completed
                    </p>
                    <div>
                      <span>{{ data.conversations.completed }} Conversations</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between border-bottom border-bottom-dashed py-2">
                    <p class="fw-medium mb-0">
                      <i class="ri-checkbox-blank-circle-fill text-primary align-middle me-2"></i> In Process
                    </p>
                    <div>
                      <span>{{ data.conversations.in_process }} Conversations</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between border-bottom border-bottom-dashed py-2">
                    <p class="fw-medium mb-0">
                      <i class="ri-checkbox-blank-circle-fill text-warning align-middle me-2"></i> Yet to Start
                    </p>
                    <div>
                      <span>{{ data.conversations.yet_to_start }} Conversations</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between py-2">
                    <p class="fw-medium mb-0">
                      <i class="ri-checkbox-blank-circle-fill text-danger align-middle me-2"></i> Failed
                    </p>
                    <div>
                      <span>{{ data.conversations.failed }} Conversations</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-auto layout-rightside-col">
      <div class="overlay" (click)="SidebarHide()"></div>
      <div class="layout-rightside mt-0">
        <div class="card h-100 rounded-0">
          <div class="card-body p-0">
            <div class="p-3">
              <h6 class="text-muted mb-0 text-uppercase fw-semibold">Recent Activity</h6>
            </div>
            <ngx-simplebar class="p-3 pt-0 file-menu-sidebar-scroll">
              <div class="acitivity-timeline acitivity-main">
                <div class="acitivity-item d-flex">
                  <div class="flex-shrink-0 avatar-xs acitivity-avatar">
                    <div class="avatar-title bg-success-subtle text-success rounded-circle shadow">
                      <i class="ri-shopping-cart-2-line"></i>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <h6 class="mb-1 lh-base">Purchase by James Price</h6>
                    <p class="text-muted mb-1">Product noise evolve smartwatch </p>
                    <small class="mb-0 text-muted">02:14 PM Today</small>
                  </div>
                </div>
                <div class="acitivity-item py-3 d-flex">
                  <div class="flex-shrink-0 avatar-xs acitivity-avatar">
                    <div class="avatar-title bg-danger-subtle text-danger rounded-circle shadow">
                      <i class="ri-stack-fill"></i>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <h6 class="mb-1 lh-base">Added new <span class="fw-semibold">style collection</span>
                  </h6>
                  <p class="text-muted mb-1">By Nesta Technologies</p>
                  <p class="mb-0 text-muted">
                    <small>9:47 PM Yesterday</small>
                  </p>
                </div>
              </div>
              <div class="acitivity-item py-3 d-flex">
                <div class="flex-shrink-0 avatar-xs acitivity-avatar">
                  <div class="avatar-title bg-danger-subtle text-danger rounded-circle shadow">
                    <i class="ri-stack-fill"></i>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <h6 class="mb-1 lh-base">Natasha Carey have liked the products</h6>
                  <p class="text-muted mb-1">Allow users to like products in your WooCommerce store. </p>
                  <small class="mb-0 text-muted">25 Dec, 2021</small>
                </div>
              </div>
              <div class="acitivity-item py-3 d-flex">
                <div class="flex-shrink-0">
                  <div class="avatar-xs acitivity-avatar">
                    <div class="avatar-title rounded-circle bg-secondary shadow">
                      <i class="mdi mdi-sale fs-14"></i>
                    </div>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <h6 class="mb-1 lh-base">Today offers by <a routerLink="/ecommerce/seller-details" class="link-secondary">Digitech Galaxy</a>
                </h6>
                <p class="text-muted mb-2">Offer is valid on orders of Rs.500 Or above for selected products only.</p>
                <small class="mb-0 text-muted">12 Dec, 2021</small>
              </div>
            </div>
            <div class="acitivity-item py-3 d-flex">
              <div class="flex-shrink-0">
                <div class="avatar-xs acitivity-avatar">
                  <div class="avatar-title rounded-circle bg-danger-subtle text-danger shadow">
                    <i class="ri-bookmark-fill"></i>
                  </div>
                </div>
              </div>
              <div class="flex-grow-1 ms-3">
                <h6 class="mb-1 lh-base">Favoried Product</h6>
                <p class="text-muted mb-2">Esther James have favorited product.</p>
                <small class="mb-0 text-muted">25 Nov, 2021</small>
              </div>
            </div>
            <div class="acitivity-item py-3 d-flex">
              <div class="flex-shrink-0">
                <div class="avatar-xs acitivity-avatar">
                  <div class="avatar-title rounded-circle bg-secondary shadow">
                    <i class="mdi mdi-sale fs-14"></i>
                  </div>
                </div>
              </div>
              <div class="flex-grow-1 ms-3">
                <h6 class="mb-1 lh-base">Flash sale starting <span class="text-primary">Tomorrow.</span>
              </h6>
              <p class="text-muted mb-0">Flash sale by <a href="javascript:void(0);" class="link-secondary fw-medium">Zoetic Fashion</a>
            </p>
            <small class="mb-0 text-muted">22 Oct, 2021</small>
          </div>
        </div>
        <div class="acitivity-item py-3 d-flex">
          <div class="flex-shrink-0">
            <div class="avatar-xs acitivity-avatar">
              <div class="avatar-title rounded-circle bg-info-subtle text-info shadow">
                <i class="ri-line-chart-line"></i>
              </div>
            </div>
          </div>
          <div class="flex-grow-1 ms-3">
            <h6 class="mb-1 lh-base">Monthly sales report</h6>
            <p class="text-muted mb-2">
              <span class="text-danger">2 days left</span> notification to submit the monthly sales report. <a href="javascript:void(0);" class="link-warning text-decoration-underline">Reports Builder</a>
            </p>
            <small class="mb-0 text-muted">15 Oct</small>
          </div>
        </div>
        <div class="acitivity-item d-flex">
          <div class="avatar-xs acitivity-avatar">
            <div class="avatar-title rounded-circle bg-info-subtle text-info shadow">
              <i class="ri-line-chart-line"></i>
            </div>
          </div>
          <div class="flex-grow-1 ms-3">
            <h6 class="mb-1 lh-base">Frank Hook Commented</h6>
            <p class="text-muted mb-2 fst-italic">" A product that has reviews is more likable to be sold than a product. "</p>
            <small class="mb-0 text-muted">26 Aug, 2021</small>
          </div>
        </div>
      </div>
    </ngx-simplebar>
  </div>
</div>
</div>
</div> -->
</div>
</ngx-simplebar>
}